import { render, staticRenderFns } from "./EstoqueSaida.vue?vue&type=template&id=c01b481e&scoped=true"
import script from "./EstoqueSaida.vue?vue&type=script&lang=js"
export * from "./EstoqueSaida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01b481e",
  null
  
)

export default component.exports